import { Box, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import fieldTranslations from 'modules/payroll_integrations_datev_api/lib/fieldTranslations'

const Unavailable = ({ unavailableFields }: { unavailableFields: string[] | null }) => {
  return (
    <>
      <Text.Header2>
        {i18n.t('payroll_integrations.incidences.datev_api.personal_data.unavailable.title')}
      </Text.Header2>
      <Box>
        {i18n.t('payroll_integrations.incidences.datev_api.personal_data.unavailable.message')}
      </Box>
      {unavailableFields && (
        <Box component="ul" paddingX="s8">
          {unavailableFields.map((field) => (
            <Box component="li" key={field}>
              {fieldTranslations.t(field)}
            </Box>
          ))}
        </Box>
      )}
    </>
  )
}

export default Unavailable
